import { useCallback, useContext, useEffect, useState } from 'react'
import { TenantsContext } from '../../../context/tenants.context'
import { AtributosProducto } from '../../Integraciones/types/responses'
import { getAtributos } from '../../AdminProducts/services/rubros.service'

const useAtributosProductos = (deviceId: string) => {
  const [loading, setLoading] = useState<boolean>(false)
  const [atributos, setAtributos] = useState<AtributosProducto[]>([])
  const { tenant } = useContext(TenantsContext)

  const fetchAtributos = useCallback(async () => {
    try {
      setLoading(true)
      const res = await getAtributos(tenant, deviceId)
      setAtributos(res.data.data)
    } catch (e) {
      console.log(e)
    } finally {
      setLoading(false)
    }
  }, [tenant])

  useEffect(() => {
    fetchAtributos()
  }, [tenant])

  return {
    atributos,
    loading
  }
}

export default useAtributosProductos
